import { combineReducers } from '@reduxjs/toolkit';
import JacksonReducer from './jackson_reducer';
import SealinkReducer from './sealink_reducer';

export default combineReducers({
  jackson: JacksonReducer,
  sealink: SealinkReducer,
});
